import { FieldWrapper, IFieldProps, IWidgetProps, register } from "decorator-form";
import React from "react";
import { v4 as generateUuid } from "uuid";


export const registerField = (field: any, dataType: string, arrayType?: string): string => {
	const uuid = generateUuid();
	register(uuid, new FieldWrapper({ dataType, uiField: (fieldProps: IFieldProps<any>) => React.createElement(field, fieldProps), arrayType }));
	return uuid;
};

export const registerWidget = (widget: any, dataType: string): string => {
	const uuid = generateUuid();
	register(uuid, new FieldWrapper({ dataType, uiWidget: (widgetProps: IWidgetProps<any>) => React.createElement(widget, widgetProps)}));
	return uuid;
};



// WEBPACK FOOTER //
// ./src/common/form/register.tsx